import './Footer/Polyfill'
import './Polyfill/closest.polyfill'
import './Polyfill/polyfill.object-fit.min'
import './Footer/NavigationDoubleTapToGo/01_DoubleTapToGo'
import './Footer/NavigationDoubleTapToGo/02_NavigationDoubleTapToGo'
import './Footer/BusinessAreaSelector'
import './Footer/Collapsible'
import './Footer/EnergyCalculatorObservation'
import './Footer/EnergyCalculatorTracking'
import './Footer/EnlargableImage'
import './Footer/LiveSupportApi'
import './Footer/MainNavigationController'
import './Footer/PageViewTracking'
import './Footer/Polyfill'
import './Footer/ScrollToTop'
import './Footer/SearchAutoCompleteController'
import './Footer/SidebarNavigation'
import './Footer/StickySidebar'
import TickerDuration from './Ticker/TickerDuration'
import ApplicationLinks from './ApplicationLinks/ApplicationLinks'
import PrintableImage from './Footer/PrintableImage'
import './InsertHtmlModal/InsertHtmlModal'

const initNodeTypesOnLoad = function () {
    new TickerDuration()
    new ApplicationLinks()
    new PrintableImage()
}

if (document.readyState !== 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}
